<ul
  class="cabinet-menu"
  [ngClass]="{'menu-expand': show()}"
>
  @for (item of menuList; track item.id) {
    <li class="cabinet-menu__item">
      <a
        class="cabinet-menu__item__link"
        [routerLink]="['/referral-cabinet', item.urlPath]"
        routerLinkActive="active"
      >{{ item.titleKey | translate }}</a>
    </li>
  }
  <li class="cabinet-menu__item">
    <a class="cabinet-menu__item__link" [routerLink]="['/cabinet', 'exchange']">
      <span>{{ 'referralCabinetMenu.exchange' | translate }}</span>
      <img src="/images/referral/arrow-left.png" alt="">
    </a>
  </li>
</ul>
